import styled, {css} from "styled-components";

export const VoucherCardFaceHeaderBox = styled.div<{isCloseToExpiration: boolean}>`
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    width: 100%;
    ${props => props.isCloseToExpiration ? css`
        color: ${props.theme.colors.danger};
        ${props.theme.font.presets.bold};
    ` : ''}
`;
